import { DockItem } from './dockItem';

export class Dock {
  constructor(
    public dock?: string,
    public items?: DockItem[],
  ) { }
}
